// src/redux/locksSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const syncLocksForWeeks = createAsyncThunk(
  'locks/syncLocksForWeeks',
  async (locksData, { rejectWithValue }) => {
    console.log('syncLocksForWeeks called with:', locksData);
    if (!locksData || Object.keys(locksData).length === 0) {
      return rejectWithValue('No locks data received');
    }
    return locksData;
  }
);

const locksSlice = createSlice({
  name: 'locks',
  initialState: {
    cache: {},
    status: 'idle',
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(syncLocksForWeeks.pending, (state) => {
        console.log('syncLocksForWeeks pending');
        state.status = 'loading';
      })
      .addCase(syncLocksForWeeks.fulfilled, (state, action) => {
        console.log('syncLocksForWeeks fulfilled with payload:', action.payload);
        state.status = 'succeeded';
        state.cache = { ...state.cache, ...action.payload };
        console.log('Updated locks cache:', state.cache);
      })
      .addCase(syncLocksForWeeks.rejected, (state, action) => {
        console.log('syncLocksForWeeks rejected with error:', action.error);
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export default locksSlice.reducer;
